import axios, { AxiosResponse } from "axios";
import { BasicInfo, Facility, Institution } from "../interfaces/Interfaces";

const APPSETTINGS = require('../appsettings.json')[process.env.NODE_ENV];

interface JWTFunctionCallParams {
    email: string,
    basicInfo: BasicInfo,
    userType: string,
    jwtResetPassword: boolean
}

export const getJWT = async (jwtBody: JWTFunctionCallParams, token: string): Promise<boolean> => {

    const params = new URLSearchParams();
    params.append("email", jwtBody.email);
    params.append("firstName", jwtBody.basicInfo.firstName);
    params.append("lastName", jwtBody.basicInfo.lastName);
    params.append("phoneNumber", jwtBody.basicInfo.phoneNumber);
    params.append("position", jwtBody.basicInfo.position);
    params.append("mobileNumber", jwtBody.basicInfo.mobileNumber);
    params.append("faxNumber", jwtBody.basicInfo.faxNumber);
    params.append("accountNumber", jwtBody.basicInfo.accountNumber);

    if (jwtBody.jwtResetPassword) {
        params.append("userRequestedPasswordChange", "true");
    }

    const GENERATE_JWT_API = process.env.NODE_ENV === 'production' ? APPSETTINGS.generatejwtapi : APPSETTINGS.generatejwtapi;

    var bearer = "Bearer " + token;

    const res: { status: number, data: any } | AxiosResponse<any> = await axios.post(GENERATE_JWT_API, params, { headers: { "Authorization": bearer } })
        .catch((e) => {
            console.log("Token generation failed");
            return { status: -1, data: e };
        });

    if (res.status === 200) {
        const urlParams = new URLSearchParams(window.location.search);
        const rduri = urlParams.get("redirect_uri");
        const state = urlParams.get("state");

        const redirecturifull = rduri + "?state=" + state + "&id_token=" + res.data;
        window.location.replace(redirecturifull);
        return true;
    }
    else {
        console.log("Token generation error, " + JSON.stringify(res.data));
        return false;
    }
}